import logo from './logo.svg';
import './App.css';
import MainPage from './pages/MainPage';
import Routes from './routes';

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;